module.exports = __webpack_public_path__ + "img/t3.75051b61.svg";